import React, { useState } from "react";
import PopupForm from "./PopupForm.js"; // Import the Popup Form
import "./CyberForensic.css";

const CyberForensic = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  return (
    <div className="cyber-forensic-container">
      {/* Hero Section */}
      <section className="hero-cyber-section">
        <div className="hero-content">
          <h1>Data Forensic</h1>
          <p>
            Investigate cyber threats, recover digital evidence, and enhance cybersecurity.
          </p>
          <button className="cta-button" onClick={() => setIsPopupOpen(true)}>
            Connect Now!
          </button>
        </div>
      </section>

      {/* About Cyber Forensics */}
      <section className="about-cf-section">
        <div className="about-content">
        <div className="vector-image">
            <img 
              src="./cb-img.png" 
              alt="Big Data Vector" 
            />
          </div>
          <div className="about-text">
            <h2>What is Data Forensic?</h2>
            <p>
            Data forensic, also known as digital forensics, is the process of collecting, analyzing, and preserving digital evidence from electronic devices to investigate cybercrimes, fraud, or data breaches. It helps in identifying unauthorized access, recovering lost data, and ensuring legal compliance in cybersecurity investigations.
            </p>
            <ul>
              <li>🔹 Digital Evidence Collection</li>
              <li>🔹 Data Recovery & Analysis</li>
              <li>🔹 Cybercrime Investigation</li>
            </ul>
          </div>
        </div>
      </section>


      {/* Features */}
      <section className="features-section">
        <h2 className="section-title">Why Choose Our Data Forensic Solution?</h2>
        <div className="features-grid">
          <div className="feature-card">
            <span className="feature-icon">🔍</span>
            <h3>Digital Investigation</h3>
            <p>Advanced tools for analyzing cyber threats.</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">🛡️</span>
            <h3>Data Security</h3>
            <p>Protect and recover compromised information.</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">📂</span>
            <h3>Evidence Management</h3>
            <p>Organized storage and retrieval of digital proof.</p>
          </div>
        </div>
      </section>

      {/* Popup Form Component */}
      <PopupForm isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} />
    </div>
  );
};

export default CyberForensic;
